/**
 * useTopic
 */

import { useState, useCallback } from 'react';
import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';
import { useMediaConfig, useLang } from '../config';
import useDidUpdate from '../useDidUpdate';

const {
    useQuery,
} = ApolloLib;
const {
    GET_TOPIC,
} = Queries;

const INITIAL_PAGE = 0;

//TODO: turn ssr, skip and limit into an options object
const useTopic = (topicId, topicOptions = {}) => {

    const {
        ssr = false,
        skip = false,
        limit = 20,
        adobeExperience,
        videoSlug,
        videoTranslationId,
        sessionId,
    } = topicOptions;
    const lang = useLang();
    const { forgeInstance = 'MLB' } = useMediaConfig();
    const [
        topicPage,
        setPage,
    ] = useState(0);
    const [
        loadingMore,
        setLoadingMore,
    ] = useState(false);

    useDidUpdate(() => {

        setPage(INITIAL_PAGE);

    }, [topicId]);

    const topicVariables = {
        topicId,
        languagePreference: lang.toUpperCase(),
        limit: limit,
        page: INITIAL_PAGE,
        forgeInstance,
    };
    if (adobeExperience) {

        topicVariables.videoSlug = videoSlug;
        topicVariables.contentGroup = adobeExperience;
        topicVariables.videoTranslationId = videoTranslationId;
        topicVariables.sessionId = sessionId;

    }

    const {
        loading,
        error,
        data,
        fetchMore,
    } = useQuery(
        GET_TOPIC,
        {
            variables: topicVariables,
            ssr,
            skip,
        }
    );

    const fetchMoreData = useCallback(() => {

        const nextPage = topicPage + 1;
        setLoadingMore(true);

        return fetchMore({
            variables: { page: nextPage },
            updateQuery: (prev, { fetchMoreResult }) => {

                setLoadingMore(false);
                setPage(nextPage);

                if (
                    !fetchMoreResult
                    || fetchMoreResult?.topicPlayList?.mediaPlayback?.length < 1
                ) return prev;

                return Object.assign({}, prev, {
                    topicPlayList: {
                        title: fetchMoreResult.topicPlayList.title,
                        puid: fetchMoreResult.topicPlayList.puid,
                        modelType: fetchMoreResult.topicPlayList.modelType,
                        modelVersion: fetchMoreResult.topicPlayList.modelVersion,
                        mediaPlayback: [
                            ...prev.topicPlayList.mediaPlayback,
                            ...fetchMoreResult.topicPlayList.mediaPlayback,
                        ],
                        hasMore: fetchMoreResult.topicPlayList.hasMore,
                        __typename: 'TopicPlayList',
                    },
                });

            },
        });

    }, [
        fetchMore,
        topicPage,
        setPage,
    ]);
    return {
        loading,
        loadingMore,
        data,
        error,
        fetchMoreData,
    };

};

export default useTopic;
